// start src/redux/slices/signalSlice.js
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://gritwears.store/api';

const initialState = {
  signals: [],
  loading: false,
  lastSignal: null,
};

const signalSlice = createSlice({
  name: 'signals',
  initialState,
  reducers: {
    addSignal: (state, action) => {
      state.signals = [action.payload, ...state.signals].slice(0, 100);
      state.lastSignal = action.payload;
    },
    setSignals: (state, action) => {
      state.signals = action.payload;
    },
    clearSignals: (state) => {
      state.signals = [];
      state.lastSignal = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { addSignal, setSignals, clearSignals, setLoading } = signalSlice.actions;

export const loadUserSignals = (userId) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axios.get(`${API_URL}/signals/${userId}`);
    dispatch(setSignals(response.data));
  } catch (error) {
    console.error('Error loading signals:', error);
  } finally {
    dispatch(setLoading(false));
  }
};

export default signalSlice.reducer;